// extracted by mini-css-extract-plugin
export default {"form":"styles_form__8Fmzd","actionWrapper":"styles_actionWrapper__Zpv2M","collapseHeader":"styles_collapseHeader__1B+YT"};